var _path, _g, _path2, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoffee(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3022_5160",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 64,
    height: 64
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H64V64H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3022_5160)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.3159 45.4736C62.3159 54.7738 48.7429 62.3157 32.0001 62.3157C15.2574 62.3157 1.68433 54.7738 1.68433 45.4736C1.68433 36.1734 15.2574 28.6315 32.0001 28.6315C48.7429 28.6315 62.3159 36.1734 62.3159 45.4736Z",
    fill: "#99AAB5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.3159 42.1052C62.3159 51.4054 48.7429 58.9473 32.0001 58.9473C15.2574 58.9473 1.68433 51.4054 1.68433 42.1052C1.68433 32.805 15.2574 25.2631 32.0001 25.2631C48.7429 25.2631 62.3159 32.805 62.3159 42.1052Z",
    fill: "#CCD6DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0002 53.8945C6.80781 53.8945 3.36865 28.6314 3.36865 21.8945H60.6318C60.6318 25.263 57.3341 53.8945 32.0002 53.8945Z",
    fill: "#F5F8FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.3804 13.3926C53.095 11.8128 50.1543 10.5396 46.7556 9.60316C49.9135 8.63306 54.4204 9.08274 55.3804 13.3926ZM59.596 17.9265C63.7089 0.878952 43.1228 4.94801 39.0419 8.16148C36.7851 7.91053 34.4339 7.76737 32.0002 7.76737C16.1872 7.76737 3.36865 13.204 3.36865 21.9888C3.36865 30.7737 16.1872 37.8945 32.0002 37.8945C47.8133 37.8945 60.6318 30.7737 60.6318 21.9888C60.6318 20.5371 60.2529 19.1863 59.596 17.9265Z",
    fill: "#CCD6DD"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_3022_5160",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 64,
    height: 64
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H64V64H0V0Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_3022_5160)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.2631 23.5789C57.2631 30.0901 45.952 35.3684 32 35.3684C18.048 35.3684 6.73682 30.0901 6.73682 23.5789C6.73682 17.0678 18.048 11.7895 32 11.7895C45.952 11.7895 57.2631 17.0678 57.2631 23.5789Z",
    fill: "#8A4B38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3684 30.3157C35.1472 30.3159 34.9281 30.2724 34.7238 30.1877C34.5194 30.103 34.3338 29.9788 34.1776 29.8222C30.2416 25.8862 30.176 21.5948 33.9671 15.9072C35.2118 14.0395 35.4829 12.1262 34.7722 10.2197C33.9958 8.13967 32.3503 6.85799 31.8568 6.72325C30.9254 6.72325 30.2433 5.97546 30.2433 5.04577C30.2433 4.1144 31.0703 3.3683 32 3.3683C33.6791 3.3683 36.0336 5.3102 37.3608 7.78935C39.1023 11.0449 38.8934 14.5919 36.7696 17.7767C33.4669 22.7317 34.1911 25.0727 36.5591 27.4407C36.7954 27.6759 36.9565 27.9761 37.0219 28.303C37.0873 28.6299 37.0542 28.9689 36.9266 29.277C36.799 29.585 36.5828 29.8482 36.3053 30.0331C36.0279 30.2181 35.7018 30.3164 35.3684 30.3157ZM25.2631 26.9472C25.0419 26.9475 24.8229 26.904 24.6185 26.8193C24.4142 26.7346 24.2286 26.6104 24.0724 26.4538C20.1364 22.5178 20.0707 18.2264 23.8619 12.5388C25.0863 10.7014 25.3675 9.0323 24.6939 7.57546C23.9461 5.95693 22.2838 5.10135 21.8576 5.05083C21.6375 5.05062 21.4197 5.00682 21.2166 4.92199C21.0135 4.83715 20.8292 4.71294 20.6743 4.55652C20.5195 4.4001 20.3971 4.21458 20.3143 4.01064C20.2316 3.8067 20.19 3.58839 20.192 3.3683C20.192 2.43693 20.965 1.68409 21.8947 1.68409C23.5739 1.68409 26.2467 3.32451 27.5536 5.76493C28.3638 7.27904 29.3271 10.415 26.6644 14.4083C23.3616 19.3632 24.0859 21.7043 26.4539 24.0723C26.6902 24.3075 26.8512 24.6076 26.9167 24.9346C26.9821 25.2615 26.9489 25.6005 26.8213 25.9086C26.6937 26.2166 26.4775 26.4798 26.2001 26.6647C25.9226 26.8496 25.5965 26.948 25.2631 26.9472Z",
    fill: "#D99E82"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoffee);
export default __webpack_public_path__ + "static/media/coffee.a7330310107fa817cea750ce9a1031f5.svg";
export { ForwardRef as ReactComponent };